<div *ngIf="assessType" class="fixed inset-0 flex items-center justify-center bg-main-background bg-opacity-75 z-20"
    (click)="closeModal()">
    <div class="w-full max-w-screen-md max-h-[90%] flex flex-row gap-1 justify-center overflow-y-auto" (click)="$event.stopPropagation()">
        <div class="flex min-w-full bg-white p-10 w-1/4 rounded-md text-center shadow-lg">
            <form (ngSubmit)="sendAssessment()" class="w-full h-full flex flex-col items-center justify-start gap-4 overflow-y-auto">
                <div class="w-full flex items-center justify-between">
                    <div class="flex items-center gap-2">
                        <div class="p-2 rounded-full bg-orange-100">
                            <lucide-icon [name]="icons.Mail" [size]="24" class="text-nside-orange-400"></lucide-icon>
                        </div>
                        <h2 class="oswald-font text-xl font-medium text-nside-orange-400 text-start">
                            Send {{ assessType.split('-')[1] || assessType }} Assessment
                        </h2>
                    </div>
                    <button (click)="$event.preventDefault(); closeModal()" type="button">
                        <lucide-icon [name]="icons.X" [size]="20" class="text-nside-gray-200"></lucide-icon>
                    </button>
                </div>
    
                <div class="w-full max-h-full flex flex-col gap-2 overflow-y-auto p-2">
                    <div *ngIf="assessType === 'AL-Classroom'" class="w-full flex items-center text-start gap-2">
                        <p class="w-20 font-semibold">Room:</p>
                        <div class="relative h-full flex flex-grow flex-col items-center">
                            <input 
                                type="text" 
                                name="room_number" 
                                [(ngModel)]="room_number"
                                #room_numberRef="ngModel"
                                class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded block w-full p-2"
                                placeholder="E.g. 101A" required />
                            <div 
                                class="w-full text-start italic text-xs text-red-500"
                                *ngIf="room_numberRef.invalid && room_numberRef.touched"
                            >
                                This field is required.
                            </div>
                        </div>
                    </div>

                    <div class="w-full flex items-center gap-2 text-start">
                        <p class="w-20 font-semibold">Survey:</p>
                        <select [(ngModel)]="selectedSubTypeId" name="sub_type_id"
                            class="bg-gray-50 border border-gray-300 text-sm rounded block flex flex-grow p-2"
                            [disabled]="currentSubTypeIds.length === 0" required>
                            <option *ngFor="let id of currentSubTypeIds" [ngValue]="id">
                                {{ subTypeLabel(id).split('-')[1] || subTypeLabel(id) }}
                            </option>
                        </select>
                    </div>
                    
                    <!-- Contacts List -->
                    <div *ngIf="emails.length > 0" class="flex flex-wrap gap-2">
                        <div *ngFor="let item of emails; let i = index"
                            class="px-2 py-1 text-sm bg-orange-100 rounded-full flex items-center gap-1">
                            {{ item.email }}
                            <button type="button" (click)="$event.preventDefault(); removeEmail(i)">
                                <lucide-icon [name]="icons.X" [size]="14" class="text-nside-orange-400"></lucide-icon>
                            </button>
                        </div>
                    </div>
    
                    <div class="flex flex-wrap gap-2 overflow-y-auto">
                        <div class="flex items-center flex-wrap gap-2 overflow-y-auto">
                            <p class="w-20 font-semibold text-start">Send to:</p>
                            <ng-container *ngFor="let contact of contactsList">
                                <button
                                    *ngIf="contact.email"
                                    class="h-10 px-2.5 py-1.5 flex items-center justify-between rounded-md border"
                                    (click)="$event.preventDefault(); addContact(contact)"
                                    [disabled]="isEmailSelected(contact.email)"
                                    [ngClass]="{
                                        'cursor-not-allowed border-gray-100 bg-gray-100 text-gray-400': isEmailSelected(contact.email),
                                        'hover:text-white hover:border-nside-orange-300 hover:bg-gradient-to-b hover:from-nside-orange-100 hover:to-nside-orange-200 border-gray-300': !isEmailSelected(contact.email)
                                    }"
                                      
                                >
                                    {{ contact.name }}
                                </button>
                            </ng-container>
                        </div> 
                    </div>
                </div>
    
                <div class="w-full flex items-center justify-end gap-3">
                    <button class="px-4 py-1.5 w-20 rounded-md border border-nside-gray-400 oswald-font"
                        (click)="$event.preventDefault(); closeModal();">
                        Close
                    </button>
                    <button type="submit"
                        class="w-20 flex items-center justify-center px-4 py-1.5 rounded-md border bg-gradient-to-b oswald-font text-white"
                        [ngClass]="{
                            'border-nside-gray-100 from-nside-gray-100 to-nside-gray-200 cursor-not-allowed': emails.length === 0,
                            'border-nside-orange-100 from-nside-orange-300 to-nside-orange-400 hover:bg-gradient-to-b hover:from-nside-orange-100 hover:to-nside-orange-200': emails.length > 0
                        }" 
                        [disabled]="emails.length === 0 || !selectedSubTypeId">Send</button>
                </div>
            </form>
        </div>
        
    </div>
</div>

<div *ngIf="loading">
    <spinner></spinner>
</div>